import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import React from "react";
import { MainContainer, Container, InfoContainer, Title } from "./styles";
import { TravelExpenseRef } from "../../../../../../../../../models/travel-expenses";

interface Props {
  travelExpense: TravelExpenseRef;
}

const AuditorDetailsForExport = ({ travelExpense }: Props) => {
  return (
    <MainContainer>
      <Container>
        <InfoContainer>
          <Title>Cost inccured:</Title>

          <>
            {travelExpense.costIncurred && (
              <FontAwesomeIcon
                icon={faCircle}
                color={"green"}
              />
            )}
          </>
        </InfoContainer>

        <Typography>{travelExpense.costIncurredComment}</Typography>
      </Container>

      <Container>
        <InfoContainer>
          <Title>Amount and type justified:</Title>

          <>
            {travelExpense.amountAndTypeJustified && (
              <FontAwesomeIcon
                icon={faCircle}
                color={"green"}
              />
            )}
          </>
        </InfoContainer>

        <Typography>{travelExpense.amountAndTypeJustifiedComment}</Typography>
      </Container>

      <Container>
        <InfoContainer>
          <Title>Complient receipt:</Title>

          <>
            {travelExpense.compliantReceipt && (
              <FontAwesomeIcon
                icon={faCircle}
                color={"green"}
              />
            )}
          </>
        </InfoContainer>

        <Typography>{travelExpense.compliantReceiptComment}</Typography>
      </Container>
    </MainContainer>
  );
};

export default AuditorDetailsForExport;
